// ContactBlockChip — QA BUG-22 (Idan 2026-10-03): «מוסר» / «שגוי» next to an e-mail address or a cellphone.
// The card's CURRENT state (server EmailBlockReason / CellBlockReason through `contactBlockOf`), NOT its state at
// send time; the tooltip says so in words (approved 4.4). Used by SendSearchTable (נמען cell), DrawerStack (header)
// and RollupDrawer (recorded and legacy roster). The caller places it OUTSIDE the LTR-isolated address / number, so
// the Hebrew word keeps the page direction. Neutral grey, NOT the warn pair (#B54708/#FCF0E6), which on this screen
// means "we cannot vouch for which version was sent". `block` null => renders nothing.
import React from 'react';
import { Chip, Tooltip, TooltipProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SS, ContactBlock } from '../../../Models/DataSources/SendSearch';

interface Props {
    block: ContactBlock | null;
    of: 'email' | 'phone';
    // Inside a drawer: { disablePortal: true } (QA BUG-02 idiom). The grid passes nothing.
    tooltipPopperProps?: TooltipProps['PopperProps'];
}

const TITLE_KEY: { [o in Props['of']]: { [b in ContactBlock]: string } } = {
    email: { removed: 'badge.emailRemovedTitle', invalid: 'badge.emailInvalidTitle' },
    phone: { removed: 'badge.phoneRemovedTitle', invalid: 'badge.phoneInvalidTitle' },
};

const ContactBlockChip: React.FC<Props> = ({ block, of, tooltipPopperProps }) => {
    const { t } = useTranslation();
    if (!block) return null;
    return (
        <Tooltip title={t(`${SS}${TITLE_KEY[of][block]}`) as string} PopperProps={tooltipPopperProps}>
            <Chip
                size="small"
                label={t(`${SS}badge.${block}`)}
                style={{ backgroundColor: 'var(--pls-d-surface-2, #EDF0F3)', color: 'var(--pls-d-text, #3b4754)', fontWeight: 800, fontSize: 11.5 }}
            />
        </Tooltip>
    );
};

export default ContactBlockChip;
